import React from 'react';
import { motion } from 'framer-motion';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css'; // Import Swiper styles

const testimonials = [
  {
    image: '/images/review-1.webp',
    name: 'David James',
    role: 'CEO',
    text: 'Excellent service and beautiful properties.'
  },
  {
    image: '/images/review-2.webp',
    name: 'John Carlson',
    role: 'Manager',
    text: 'They truly care about their clients.'
  },
  {
    image: '/images/review-6.webp',
    name: 'Virginia Henry',
    role: 'Developer',
    text: 'Amazing design and reliable team.'
  },
  {
    image: '/images/review-1.webp',
    name: 'Alice Smith',
    role: 'Designer',
    text: 'Great experience and beautiful homes.'
  },
  {
    image: '/images/review-2.webp',
    name: 'Tom Riddle',
    role: 'Architect',
    text: 'Very professional and reliable.'
  }
];

export default function TestimonialsSection() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.6 }}
      className="py-5 bg-light"
    >
      <div className="container">
        <h2 className="text-center text-primary">What Client's Say</h2>
        <Swiper
          spaceBetween={30} // Space between slides
          slidesPerView={3} // Show 3 slides per view
          autoplay={{ delay: 3000 }} // Auto-slide every 3 seconds
          loop={true} // Loop through the slides
          breakpoints={{
            320: { slidesPerView: 1 }, // 1 slide for small screens
            768: { slidesPerView: 2 }, // 2 slides for screens >= 768px
            1024: { slidesPerView: 3 } // 3 slides for screens >= 1024px
          }}
          className='bg-transparent py-3'
        >
          {testimonials.map((testimonial, index) => (
            <SwiperSlide key={index}>
              <div className="card text-center border-0 shadow mb-3 ">
                <img
                  src={testimonial.image}
                  alt={testimonial.name}
                  className="rounded-circle mx-auto mt-4"
                  style={{ width: '60px', height: '60px' }}
                />
                <div className="card-body">
                  <h5>{testimonial.name}</h5>
                  <p className="text-muted">{testimonial.role}</p>
                  <p>{testimonial.text}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </motion.div>
  );
}
